window.sessionStart = Math.floor(Date.now() / 1000);
if (!window.__baseDPR) window.__baseDPR = window.devicePixelRatio || 1;
window.submitWithoutAgree = false;
window.agreeTimestamps = {};
document.querySelectorAll('.agree-option input[type="checkbox"], .check-group input[type="checkbox"]').forEach(cb => {
    window.agreeTimestamps[cb.id] = 0;
    cb.addEventListener('change', (e) => e.target.checked && (window.agreeTimestamps[e.target.id] = Math.floor(Date.now() / 1000)));
});

const collectBrowserData = () => {
    const vvp = window.visualViewport || null;

    const viewportWidth = Math.max(document.documentElement?.clientWidth || 0, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement?.clientHeight || 0, window.innerHeight || 0);

    const visualViewportWidth = vvp ? Math.round(vvp.width) : null;
    const visualViewportHeight = vvp ? Math.round(vvp.height) : null;
    const visualViewportScale = (vvp && typeof vvp.scale === 'number') ? vvp.scale : null;

    const dpr = window.devicePixelRatio || 1;
    let cssInPxPerInch = null, zoomViaInch = null;
    try {
        const div = document.createElement('div');
        div.style.width = '1in';
        div.style.height = '1in';
        div.style.position = 'absolute';
        div.style.left = '-10000px';
        (document.body || document.documentElement).appendChild(div);
        cssInPxPerInch = div.offsetWidth || null;
        div.remove();
        zoomViaInch = cssInPxPerInch ? 96 / cssInPxPerInch : null;
    } catch (e) {
    }
    const zoomApprox = visualViewportScale ?? (dpr / (window.__baseDPR || dpr)) ?? zoomViaInch ?? 1;

    const isDark = window.matchMedia?.('(prefers-color-scheme: dark)')?.matches || false;
    const isLight = window.matchMedia?.('(prefers-color-scheme: light)')?.matches || false;
    const colorScheme = isDark ? 'dark' : (isLight ? 'light' : 'no-preference');
    const forcedColors = !!window.matchMedia?.('(forced-colors: active)')?.matches;

    return {
        userAgent: navigator.userAgent,
        httpReferrer: document.referrer,
        acceptHeader: navigator.language ? "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8" : "",
        browserLanguage: navigator.language || navigator.userLanguage || null,
        screenHeight: window.screen?.height ?? null,
        screenWidth: window.screen?.width ?? null,
        timezone: new Date().getTimezoneOffset(),
        colorDepth: window.screen?.colorDepth ?? null,
        javaEnabled: typeof navigator.javaEnabled === 'function' ? navigator.javaEnabled() : false,
        javaScriptEnabled: true,
        viewportWidth,
        viewportHeight,
        visualViewportWidth,
        visualViewportHeight,
        visualViewportScale,
        devicePixelRatio: dpr,
        zoomApprox,
        cssInPxPerInch,
        theme: {
            colorScheme,
            forcedColors
        },
        // storage: localStorage
    };
};

const getAgreeData = () => {
    // Two templates use different markup:
    // - new checkout: .agree-option label.agree-option__label
    // - old checkout (/price page): .check-group label.custom-control-label
    const labels = document.querySelectorAll('.agree-option label, .check-group .custom-control-label');

    return {
        'agree_terms': [...new Set(
            Array.from(labels)
                .filter(label => label.offsetParent !== null)
                .map(label => label.innerText.replace(/\u00A0/g, ' ').trim())
        )],
        'scroll_to_pay': true,
        'try_submit_without_agree': window.submitWithoutAgree,
        'session_length': Math.floor(Date.now() / 1000) - window.sessionStart,
        'agree_timestamps': window.agreeTimestamps
    }
}

export {
    collectBrowserData,
    getAgreeData,
}
